import { render, staticRenderFns } from "./invite.page.vue?vue&type=template&id=733685bc&scoped=true&"
import script from "./invite.page.vue?vue&type=script&lang=js&"
export * from "./invite.page.vue?vue&type=script&lang=js&"
import style0 from "./invite.page.vue?vue&type=style&index=0&id=733685bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733685bc",
  null
  
)

export default component.exports